import RentList from './rent_list'
import connect from './connect'

export default connect(RentList)
